// client/src/hooks/useNotification.js

import { useState, useEffect } from 'react';
import notificationService from '../services/notificationService';

/**
 * Hook personnalisé pour utiliser le service de notification
 * @returns {Object} - Fonctions et données liées aux notifications
 */
export const useNotification = () => {
  const [notifications, setNotifications] = useState(notificationService.notifications);

  // S'abonner aux changements de notification
  useEffect(() => {
    const unsubscribe = notificationService.addListener(setNotifications);
    
    // Nettoyage lors du démontage
    return unsubscribe;
  }, []);

  // Fonctions pour manipuler les notifications
  const showNotification = (message, type, duration) => {
    return notificationService.addNotification(message, type, duration);
  };
  
  const removeNotification = (id) => {
    return notificationService.removeNotification(id);
  };
  
  const clearAllNotifications = () => {
    return notificationService.clearAllNotifications();
  };
  
  // Fonctions raccourcies par type
  const success = (message, duration) => notificationService.success(message, duration);
  const error = (message, duration) => notificationService.error(message, duration);
  const warning = (message, duration) => notificationService.warning(message, duration);
  const info = (message, duration) => notificationService.info(message, duration);

  return {
    notifications,
    showNotification,
    removeNotification,
    clearAllNotifications,
    success,
    error,
    warning,
    info
  };
};

// Also export as default for backward compatibility
export default useNotification;